import { render } from "./BasePaginationLinks.vue?vue&type=template&id=8c752694"
import script from "./BasePaginationLinks.vue?vue&type=script&lang=js"
export * from "./BasePaginationLinks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__